(function(app) {

    app.provider("advisorApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};
                    //GETs
                    service.get = function(advisorId) {
                        return crmApiGateway.get("/Advisors/" + advisorId);
                    };

                    service.getAdvisors = function() {
                        return crmApiGateway.get("/Advisors");
                    };

                    service.searchAdvisors = function(term) {
                        return crmApiGateway.getArray("/Advisors/Search?q=" + term);
                    };

                    service.getCurrentUserParentAdvisors = function() {
                        return crmApiGateway.getArray("/Me/Advisors/Parents");
                    };

                    //PUTs
                    service.update = function(advisor) {
                        return crmApiGateway.put("/Advisors/" + advisor.Id, advisor);
                    };

                    //POSTs
                    service.add = function(advisor) {
                        return crmApiGateway.post("/Advisors", advisor);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line